import { render, staticRenderFns } from "./addSave.vue?vue&type=template&id=3952a198&scoped=true&"
import script from "./addSave.vue?vue&type=script&lang=js&"
export * from "./addSave.vue?vue&type=script&lang=js&"
import style0 from "./addSave.vue?vue&type=style&index=0&id=3952a198&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3952a198",
  null
  
)

export default component.exports